import React from 'react' // eslint-disable-line no-unused-vars
import BreadCrumbs from './BreadCrumbs'
import ProductDocumentation from './ProductDocumentation'
import ProductDocumentSearch from './ProductDocumentSearch'
import Footer from '../Footer'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { PERMISSIONS } from '../../constants'
import StaticConfig from '../StaticConfig'

class ProductDetails extends React.Component {
    constructor(props) {
        super(props)

        // Show mobile version if screen width is below 576px
        this.widthQuery = window.matchMedia('(min-width: 576px)');

        this.state = {
            showMobileVersion: !this.widthQuery.matches
        }
    }

    componentDidMount() {
        this.widthQuery.addEventListener('change', this.handleMediaChange)
    }

    componentWillUnmount() {
        this.widthQuery.removeEventListener('change', this.handleMediaChange)
    }

    handleMediaChange = (e) => this.setState({ showMobileVersion: !e.matches })

    handleOpenDigitalAssistant = () => {
        if (StaticConfig.assistantRef && StaticConfig.assistantRef.current) {
            StaticConfig.assistantRef.current.getWrappedInstance().openFromExternalComponent()
        }
    }

    render() {
        const { pageContent, products, location, match } = this.props

        let product = null
        if (products) {
            const productId = parseInt(match.params.productId, 10)
            product = products.find(p => p.id === productId)
        }
        if (!product) {
            return null
        }
        if (product.parentId) {
            return <Redirect to={`/products/${product.parentId}`} />
        }

        const languageContent = pageContent.content.module.products.details
        return (
            <div className='page-container'>
                <div className='page-content'>
                    <div className='container product-details-container'>
                        <BreadCrumbs languageContent={languageContent} product={product} location={location} />
                        <h1 id='brandName' className='brand-name'>{product.brandName}</h1>
                        <p id='genericName' className='generic-name'>{product.genericName}</p>
                        <div className='row-separator' />
                        {
                            product.availableToPatientPortalForSearch &&
                            <ProductDocumentSearch
                                product={product}
                                showMobileVersion={this.state.showMobileVersion}
                            />
                        }
                        {
                            product.availableToPatientPortalForSearch &&
                            <div className='row-separator' />
                        }
                        <ProductDocumentation
                            product={product}
                            showMobileVersion={this.state.showMobileVersion}
                        />
                    </div>
                </div>
                    <div className='product-section-header'>
                        <div className='container product-details-container' style={{paddingTop:'1rem', marginBottom:0}}>
                            <h3 className='section-header'>
                                {languageContent.notFindingWhatYoureLookingFor}
                            </h3>
                            <div className='row link-section'>
                                {
                                    this.props.assistant.assistantEnabled &&
                                    <div className='col-md sub-section'>
                                        <h6 className='dark-column-header'>
                                            {languageContent.askAmi}
                                        </h6>
                                        <p>
                                            {languageContent.askAmiSubHeader}
                                        </p>
                                        <button className='text-button' onClick={this.handleOpenDigitalAssistant}>
                                            {languageContent.openAmiDigitalAssistant}
                                        </button>
                                    </div>
                                }
                                {
                                    this.props.permissions.indexOf(PERMISSIONS.SUBMIT) !== -1 &&
                                    <div className='col-md sub-section'>
                                        <h6 className='dark-column-header'>
                                            {languageContent.submitInquiry}
                                        </h6>
                                        <p>
                                            {languageContent.submitInquirySubHeader}
                                        </p>
                                        <Link to={{
                                            pathname: '/submit-inquiry',
                                            state: { productId: product.productMasterId }
                                        }}
                                            data-tag='track-link'
                                            data-analytics-text='Submit Inquiry'
                                            className='anchor-link'
                                            style={{ whiteSpace: 'normal' }}
                                        >
                                            {languageContent.submitInquiryLinkBefore}{product.brandName}
                                        </Link>
                                    </div>
                                }
                                <div className='col-md'>
                                    <h6 className='dark-column-header'>
                                        {languageContent.contactUs}
                                    </h6>
                                    <p>
                                        {languageContent.contactUsSubHeader}
                                        {' '}
                                        <a
                                            href='tel:8446633742'
                                            className='anchor-link'
                                        >
                                            844-663-3742
                                        </a>
                                        {'.'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                <Footer submitInquiry={false} showHomeFooter={false} />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    pageContent: state.pageContent,
    products: getProducts(state.referenceData),
    permissions: state.permissions,
    assistant: state.assistant
})

const mapDispatchToProps = dispatch => ({})

const getProducts = (referenceData) => {
    const data = referenceData.filter(item => item.type === 'REF_DATA').pop()
    return data ? data.referenceData.brandNameGenericProducts : []
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails)



// WEBPACK FOOTER //
// ./src/mi-app/products/ProductDetails.js